const e = "_expandable_14fx8_7", n = "_tag_14fx8_32", t = "_button_14fx8_38", _ = "_chevron_14fx8_69", o = "_content_14fx8_78", l = "_blue_14fx8_96", c = "_white_14fx8_99", s = "_open_14fx8_105", x = "_line_14fx8_109", a = "_darkblue_14fx8_119", b = "_yellow_14fx8_127", f = {
  expandable: e,
  tag: n,
  button: t,
  chevron: _,
  content: o,
  blue: l,
  white: c,
  open: s,
  line: x,
  darkblue: a,
  yellow: b
};
export {
  l as blue,
  t as button,
  _ as chevron,
  o as content,
  a as darkblue,
  f as default,
  e as expandable,
  x as line,
  s as open,
  n as tag,
  c as white,
  b as yellow
};
//# sourceMappingURL=expandable.module.less.js.map
